import {
  createEmptyShipmentAddress,
  createEmptyShipmentPerson,
  type ShipmentFields,
  type Template,
} from '@logistiek-zonder-papier/lzp-library'

export function createEmptyShipmentTemplate(): Template {
  return {
    ...createEmptyShipmentFields(),
    type: 'ecmr',
    name: '',
    loadEmailAddresseses: [],
    unloadEmailAddresses: [],
    isAmountRequired: null,
    isCommentRequired: null,
    isPhotoRequired: null,
  }
}

export function createEmptyShipmentFields(): ShipmentFields {
  return {
    fromAddress: createEmptyShipmentAddress(),
    toAddress: createEmptyShipmentAddress(),
    fromPerson: createEmptyShipmentPerson(),
    toPerson: createEmptyShipmentPerson(),
    waybillItems: [],
  }
}
